import { toUpper } from 'lodash/fp';

export function getShortInvoiceId(id: string) {
  const lastPartOfInvoiceId = toUpper(id.slice(-5));

  return `INV-${lastPartOfInvoiceId}`;
}
